import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ReplayIcon from '@mui/icons-material/Replay';
import './controls.styles.css';
import ThemeContext from '../../../config/themeContext';

export default function ReplayButtonBig({ videoPlayer }) {
  const theme = useContext(ThemeContext);

  function handlerClick() {
    videoPlayer.replay();
  }
  return (
    <div className="tpx-playbig replay" onClick={handlerClick}>
      <ReplayIcon sx={theme.imageIconBig} />
    </div>
  );
}

ReplayButtonBig.propTypes = {
  videoPlayer: PropTypes.object.isRequired,
  // playlistmodel: PropTypes.object.isRequired,
};
